import { DeviceTwinPropertyDto, Equipment, PropertyState } from 'shared/api/api';

export const getIpAddressKey = (equipment: Equipment): string => `${equipmentPrefix(equipment)}EndpointAddress`;

export const getDesiredPropertyValue = (properties: DeviceTwinPropertyDto[] | undefined, name: string): string =>
	properties?.find(p => p.propertyName === name && p.state === PropertyState.Desired)?.value ?? '';

export const getPropertyValue = (
	properties: DeviceTwinPropertyDto[] | undefined,
	name: string,
	state: PropertyState,
): string => properties?.find(p => p.propertyName === name && p.state === state)?.value ?? '—';

export const equipmentPrefix = (equipment: Equipment): string => {
	switch (equipment) {
		case Equipment.Distriwin:
			return 'distriwin';
		case Equipment.ESF:
			return 'esf';
		case Equipment.Elistar:
			return 'elistar';
	}
};
